/**-------------------------------------------------------------------------
 * Modal to allow customers to update their account password
 */
import i18n from 'i18next';

const { UI } = Mobi2Go;
const { Customer } = Mobi2Go;
const { validator } = Mobi2Go.helpers;

Mobi2Go.UI.View({
    name: 'customer_email_updater',
    model: 'Customer',
    el: '[data-view="customer-email-updater"]',
    initialise() {
        this.modal = new Mobi2Go.UI.Modal(this.$el);
        UI.bind('showCustomerEmailUpdater', this.open);

        this.$el.localize();
    },
    open() {
        if (this.modal.is_open) {
            return;
        }

        this.modal.open();
        this.resetWarnings();
        this.clearInputs();
    },
    submit() {
        const email = this.jQuery('[data-new-email-address]').val();
        const password = this.jQuery('[data-password]').val();

        // Reset warnings
        this.resetWarnings();

        const email_validation = validator.email(email);
        if (!email_validation.is_valid) {
            this.jQuery('[data-invalid-email-address-warning]')
                .removeClass('m2g-hidden')
                .find('[data-content]')
                .text(i18n.t('customer.email-updater:enter_valid_email'));

            this.jQuery('[data-new-email-address]')
                .addClass('m2g-form-element--invalid')
                .focus();

            return;
        }

        const password_validation = validator.password(password);
        if (!password_validation.is_valid) {
            this.jQuery('[data-incorrect-password-warning]')
                .removeClass('m2g-hidden')
                .find('[data-content]')
                .text(i18n.t('customer.email-updater:enter_valid_password'));
            this.jQuery('[data-password]')
                .addClass('m2g-form-element--invalid')
                .focus();

            return;
        }

        UI.centeredAlert({
            title: i18n.t('customer.email-updater:updating_email_title'),
            body: i18n.t('customer.email-updater:updating_email_body'),
            temp: true,
            temp_duration: 1000,
            show_progress_bar: true,
            primary_button: null,
        });

        // Add a little artificial delay to give time for the loading
        // alert to be displayed to avoid causing confusion
        setTimeout(function() {
            Customer.updateEmail(email, password);
        }, 400);
    },
    updateSuccess() {
        this.modal.close();
    },
    updateFail(reason) {
        UI.closeAlert();
        this.resetWarnings();

        switch (reason) {
            case 'incorrect password':
                this.jQuery('[data-incorrect-password-warning]')
                    .removeClass('m2g-hidden')
                    .find('[data-content]')
                    .text(i18n.t('customer.email-updater:incorrect_password'));
                break;

            case 'email in use':
                this.jQuery('[data-invalid-email-address-warning]')
                    .removeClass('m2g-hidden')
                    .find('[data-content]')
                    .text(i18n.t('customer.email-updater:email_in_use'));

                break;
        }
    },
    resetWarnings() {
        this.hideInvalidEmailWarning();
        this.hideIncorrectPasswordWarning();
    },
    hideInvalidEmailWarning() {
        this.jQuery('[data-password], [data-new-email-address]').removeClass(
            'm2g-form-element--invalid'
        );
    },
    hideIncorrectPasswordWarning() {
        this.jQuery(
            '[data-incorrect-password-warning], ' +
                '[data-invalid-email-address-warning]'
        ).addClass('m2g-hidden');
    },
    clearInputs() {
        this.jQuery('[data-password], [data-new-email-address]').val('');
    },
    primeEmailInUseCheck() {
        const email = this.jQuery('[data-new-email-address]').val();
        if (validator.email(email).is_valid) {
            Customer.isEmailRegistered(email);
        }
    },
    updateSubmitButtonStyle() {
        const password = this.jQuery('[data-password]').val();
        const new_email = this.jQuery('[data-new-email-address]').val();
        const is_password_valid = validator.password(password).is_valid;
        const is_email_valid = validator.email(new_email).is_valid;

        if (is_email_valid) {
            this.hideInvalidEmailWarning();
        }

        if (is_password_valid) {
            this.hideIncorrectPasswordWarning();
        }

        if (is_password_valid && is_email_valid) {
            this.jQuery('[data-submit]').addClass('m2g-button--primary');
        } else {
            this.jQuery('[data-submit]').removeClass('m2g-button--primary');
        }
    },
    DOM_listeners: {
        'keyup [data-new-email-address]': function(e) {
            this.primeEmailInUseCheck();
            if (e.keyCode === 13) {
                this.jQuery('[data-password]').focus();
            } else {
                this.updateSubmitButtonStyle();
            }
        },
        'keyup [data-password]': function(e) {
            if (e.keyCode === 13) {
                this.submit();
            } else {
                this.updateSubmitButtonStyle();
            }
        },
        'click [data-submit]': 'submit',
    },
    model_listeners: {
        updateEmail: 'updateSuccess',
        updateEmailFail: 'updateFail',
    },
});
